// Get Shopify Collection Variant Counts
export const GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_REQUEST = 'GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_REQUEST';
export const GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_DONE = 'GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_DONE';
export const GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_FAILED = 'GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_FAILED';
export const GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_RESET = 'GET_SHOPIFY_COLLECTION_VARIANT_COUNTS_RESET';
